import useApi from '../../../../services/useApi'
import {boardModulesData} from '../../parsings'
import {useContext} from 'react'
import {ProjectDetailsContext} from '../../context'

const useGetBoardModulesList = () => {
  const Api = useApi()
  const {projectId} = useContext(ProjectDetailsContext)

  const {data: response, isFetching} = Api.useGetQuery(`/agile/projects/${projectId}/modules`, {
    queryId: 'board-modules',
  })

  return {
    boardModulesList: boardModulesData(response?.data),
    isLoading: isFetching,
  }
}

export default useGetBoardModulesList
